import * as React from "react";
import {Button, Grid, LinearProgress, Link, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import {useState} from "react";
import {ExitIcon} from "./SvgIcons";
import axios from "axios";
import {redirectToMainPage} from "../../../pages/oauthPage";
import {getBackendURL, httpResponse, httpResponseError} from "../../../fn";
import {ButtonBase} from "./Button";

export default function Head({progress, button1}) {
  const [showProgress, setShowProgressState] = useState(false);
  
  let progressLine;
  
  if (progress) {
    progressLine = <LinearProgress/>
  }
  /**
   *
   *           <Box sx={{color: '#fff', lineHeight: '50px'}}>
   *             <a href="/"><Button sx={{color: '#fff'}}>Список</Button></a>
   *           </Box>
   */
  return (
    <div className="App">
      <Grid container spacing={0} id="appHead">
        <Grid item xs={6} sx={{color: '#fff', lineHeight: '50px'}}>
          {button1 || void 0}
        </Grid>
        <Grid item xs={6}>
          <Box sx={{lineHeight: '50px', alignContent: 'center', height: '50px'}} display="flex" justifyContent="flex-end">
            <LogOut/>
          </Box>
        </Grid>
      </Grid>{progressLine}
    </div>
  )
}

export function LogOut() {
  const logout = async () => {
    await new Promise((resolve) => {
      axios.get(`${getBackendURL()}/oauth/logout/`, {
        withCredentials : true,
        headers: {
          'content-type': 'application/json',
        },
      }).then((response) => {
        resolve(httpResponse(response.data))
      }).catch((error) => {
        resolve(httpResponseError(error));
      });
    })
    
    redirectToMainPage();
  }
  
  return (
            <ButtonBase variant="text" onClick={logout}>
              <ExitIcon size={24}/>
            </ButtonBase>
  )
}